import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { toUI } from '../../utility/mapStaticData';
import { scrollChildIntoView } from '../../utility/scrollIntoView';

import './User.css';

class User extends Component {
  static get propTypes() {
    return {
      user: PropTypes.object,
      userGroups: PropTypes.arrayOf(PropTypes.shape({
        Id: PropTypes.number,
        Name: PropTypes.string,
        Active: PropTypes.bool
      })),
      allGroups: PropTypes.arrayOf(PropTypes.shape({
        Id: PropTypes.number,
        Name: PropTypes.string,
        Active: PropTypes.bool
      })),
      onAddGroup: PropTypes.func.isRequired,
      onRemoveGroup: PropTypes.func.isRequired
    };
  }

  render() {
    const { user } = this.props;

    return (<tr key={user.Id}>
      <td className="name">{user.Name}</td>
      <td className="groups">
        <div className="AdminUsers-groups">
          {this.renderCurrentGroups()}
          {this.renderNewGroup()}
        </div>
      </td>
    </tr>);
  }

  renderCurrentGroups() {
    const { userGroups } = this.props;
    return userGroups && userGroups.map(g => this.renderCurrentGroup(g));
  }

  renderCurrentGroup(group) {
    const { onRemoveGroup } = this.props;

    return group && <div className={classnames('AdminUsers-group', { active: group.Active })} key={group.Id}>
      <span>{group.Name}</span>
      <button
        className="AdminUsers-removegroup"
        onClick={() => onRemoveGroup(group)}
      />
    </div>;
  }

  renderNewGroup() {
    const { userGroups, allGroups, onAddGroup } = this.props;
    if (!allGroups) return undefined;

    const mappedGroups = allGroups
      .filter(group => group.Active && !userGroups.find(g => g.Id === group.Id))
      .map(toUI.adminGroup);

    if (!mappedGroups.length) return undefined;

    let element;
    return (<Select
      placeholder={'Add Group'}
      className="AdminUsers-addgroup"
      valueKey="value"
      options={mappedGroups}
      onChange={selected => onAddGroup(this.unMapGroup(selected))}
      ref={(el) => { element = el && el.wrapper; }}
      onOpen={() => scrollChildIntoView(element, '.Select-menu-outer')}
    />);
  }

  unMapGroup(mapped) {
    const { allGroups } = this.props;
    return allGroups.find(g => toUI.adminGroup(g).value === mapped.value);
  }
}
export default User;



// WEBPACK FOOTER //
// ./src/admin/users/User.js